import axios from "../../../axios";
import { useNavigate } from 'react-router-dom';
import React, { useState } from "react";
import "./queryList.css";

const DeleteQuery = ({ setQuery, queryId, setDeleteQuery, setDelQuery, getQueryNew }) => {
  const navigate = useNavigate();
  let studentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [isInProgress, setIsInProgress] = useState(false);
  let user_id = studentData?.id;

  const handleDeleteQuery = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(`/query/delete/${queryId}`, {
        data: { user_id }
      });
      res && getQueryNew()
      setDelQuery(true);
      setDeleteQuery(false);
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };
  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={(e) => setDeleteQuery(false)}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to delete this query thread?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleDeleteQuery}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              onClick={(e) => setDeleteQuery(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteQuery;
